
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'

export default {
    name: 'ModalOrderProcess',

    components: {
        ModalEducateUsers,
    },

    data() {
        return {
            steps: [],
        }
    },

    created() {
        this.steps = [
            {
                title: `${this.$t('labels.lowest-order-minimums-title')}`,
                description: this.$t(
                    'labels.lowest-order-minimums-description'
                ),
                backgroundColor: '#42594F',
                imageUrl:
                    require('~assets/images/how-oc-works/order-process-image-01.svg'),
            },
            {
                title: `${this.$t('labels.fulfilled-by-brands-title')}`,
                description: this.$t('labels.fulfilled-by-brands-description'),
                backgroundColor: '#42594F',
                imageUrl:
                    require('~assets/images/user-education/how-works-modal-image-02.svg'),
            },
            {
                title: this.$t('labels.instant-answers-title'),
                description: this.$t('labels.instant-answers-description'),
                backgroundColor: '#42594F',
                imageUrl:
                    require('~assets/images/how-oc-works/order-process-image-03.svg'),
            },
            {
                title: `${this.$t('labels.easily-reorder-title')}`,
                description: this.$t('labels.easily-reorder-description'),
                backgroundColor: '#42594F',
                imageUrl:
                    require('~assets/images/how-oc-works/order-process-image-04.svg'),
            },
        ]
    },
}
